<template>
  <zb-modal
    ref="moreModal"
    noPadding
    contentClass="relative"
    :showCloseIcon="false"
    class="slide-in-modal"
    @close="$emit('close')"
  >
    <template #title="{ modal }">
      <div class="w-full">
        <div class="flex items-center container-sm py-6 lg:p-6 justify-between">
          <div>
            <h4 class="fs-20 font-medium flex-1">Your stay</h4>
          </div>

          <button type="button" class="fs-16" @click="modal.hide">
            <div class="flex items-center">
              <strong class="mr-3">Close</strong>
              <svg width="24" height="24">
                <use xlink:href="/img/sprite.svg#ic_close"></use>
              </svg>
            </div>
          </button>
        </div>

        <hr class="border border-black-30 w-full" />
      </div>
    </template>

    <template v-if="supplier">
      <div class="lg:px-6 lg:pb-6">
        <booking-invoice
          :supplierName="supplier.name"
          :dates="bookingDates"
          :roomsFilter="bookingRooms"
          :location="supplier.country.name || supplier.destination.name"
        >
          <template v-slot:button>
            <button
              v-if="showSelectRoomMobile"
              @click="onSelectGroup()"
              class="flex items-center btn btn-primary btn-outlined justify-center w-full mt-10"
            >
              Select room {{ unselectedGroups.join(" & ") }}
            </button>
            <button
              v-else
              @click="continueToReserve"
              class="flex items-center btn btn-primary justify-center w-full mdsm:mt-10"
            >
              Continue to reserve
            </button>
          </template>

          <template v-slot:warning>
            <div v-if="!hiddenError && showError" class="booking-error">
              <svg fill="#e12f22" width="48" height="24">
                <use xlink:href="/img/sprite.svg#ic_info"></use>
              </svg>
              <span class="ml-2">
                You have selected fewer rooms than you requested. Please make a
                selection for all rooms
              </span>
            </div>
          </template>
        </booking-invoice>
        <div class="wrap-panel mt-5 sm:mt-6">
          <service-room
            class-name="flex flex-col gap-1 px-8 py-6 sm:gap-2 sm:px-4 sm:py-6"
          />
        </div>
      </div>
    </template>
  </zb-modal>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import AmenityIcon from "./AmenityIcon.vue";
import RoomImageCarousel from "./RoomImageCarousel.vue";
import BookingInvoice from "./BookingInvoice";
import ServiceRoom from "./ServiceRoom";

export default {
  components: {
    AmenityIcon,
    RoomImageCarousel,
    BookingInvoice,
    ServiceRoom,
  },
  props: ["showPriceDetails"],
  data() {
    return {
      supplier: null,
      showError: false,
    };
  },
  mounted() {
    window.fetchSupplierInfo(this.resortId).then((response) => {
      this.supplier = response.supplier;
    });
  },
  computed: {
    ...mapState([
      "bookingDates",
      "selectedRooms",
      "bookingRooms",
      "groupsResult",
      "requestHash",
    ]),
    ...mapGetters(["applyRoomMarkup", "getSelectedRoomDetails", "getAllState"]),

    showSelectRoomMobile() {
      const isTablet = window.matchMedia(
        "(min-width: 601px) and (max-width: 1200px)"
      ).matches;
      const isMobile = window.matchMedia("(max-width: 600px)").matches;
      return (
        (isMobile || isTablet) &&
        this.getSelectedRoomDetails.length < this.bookingRooms.length
      );
    },
    hiddenError() {
      return (
        this.showError &&
        this.bookingRooms.length === this.getSelectedRoomDetails.length
      );
    },
    unselectedGroups() {
      const selectedGroups = this.getSelectedRoomDetails.map((room) =>
        room.group.slice(5)
      );

      let results = [];
      for (let i = 1; i <= this.bookingRooms.length; i++) {
        if (!selectedGroups.includes(i.toString())) {
          results.push(i);
        }
      }
      return results;
    },
  },
  methods: {
    onSelectGroup() {
      if (this.unselectedGroups[0]) {
        this.$store.commit(
          "setSelectedGroupId",
          `group-${this.unselectedGroups[0]}`
        );
      }
      this.$emit("modal-close");

      this.$nextTick(() => {
        document.querySelector(".hbt-price-search-cta").scrollIntoView({
          behavior: "smooth",
        });
      });
    },
    continueToReserve() {
      if (this.bookingRooms.length > this.getSelectedRoomDetails.length) {
        this.showError = true;
      } else {
        this.showError = false;

        const data = {
          dates: [
            moment(this.bookingDates[0]).format("YYYY-MM-DD"),
            moment(
              this.bookingDates[1] ? this.bookingDates[1] : this.bookingDates[0]
            ).format("YYYY-MM-DD"),
          ],
          ...this.getAllState,
        };

        localStorage.setItem("hbtResortData", JSON.stringify(this.getAllState));
        window.location.href = "/booking";
      }
    },
  },
  watch: {
    showPriceDetails(value) {
      if (value) {
        this.$refs.moreModal.show();
      } else {
        this.$refs.moreModal.hide();
      }
    },
  },
};
</script>

<style scoped>
.wrap-panel {
  border-radius: 4px;
  background: rgba(214, 232, 242, 0.5);
}

.close-btn {
  position: absolute;
  top: 3rem;
  right: 3rem;
  z-index: 10;
  cursor: pointer;
}
</style>
